import { QuestionContext } from '../../Helpers/QuestionContextHelper';
import { LocalitiesSearchResultDto, LocalityDto } from '../TravelExpenses/TravelExpenseDto';
import { ProduitDto, SuggestionDto } from './ProduitDto';

export enum QuestionStep {
    Infos = 'Infos',                            //!\\ (par pièce, ouvertures et autres éléments)

    StepHabitation = 'StepHabitation',
    StepTva = 'StepTva',                        //!\\ (par pièce)
    StepProduit = 'StepProduit',                //!\\ (par pièce)
    StepPose = 'StepPose',                      //!\\ (par pièce)
    StepSupport = 'StepSupport',                //!\\ (par pièce)
    StepPreparation = 'StepPreparation',        //!\\ (par pièce)
    StepFinitions = 'StepFinitions',            //!\\ (par pièce, ouvertures et autres éléments)

    StepServices = 'StepServices',              //!\\ (général) dans fin de parcours - options
    StepSynthese = 'StepSynthese',              //!\\ (général) dans fin de parcours - synthese
}

export enum QuestionType {
    SingleChoice = 'SingleChoice',
    MultipleChoices = 'MultipleChoices',
    Number = 'Number',
    Comment = 'Comment',
    Produit = 'Produit',
    MultipleChoicesProduit = 'MultipleChoicesProduit',
    MultipleChoicesPrestation = 'MultipleChoicesPrestation',
    Respiration = 'Respiration',
    ZipCode = 'ZipCode',
}

export enum QuestionContextType {
    General = 'General',
    Rooms = 'Rooms',
    Walls = 'Walls',
    Stairs = 'Stairs',
    Openings = 'Openings',
    RoomElements = 'RoomElements',
}

export enum PrixContextType {
    MetierDePose = 'MetierDePose',
    Rooms = 'Rooms',
    Walls = 'Walls',
    Stairs = 'Stairs',
    Openings = 'Openings',
    RoomElements = 'RoomElements',
}

export interface ProductFamilySummary { id: string; name: string; }

export interface ConditionDto { json_logic: string; }

export interface Infobulle { id: string; index: number; label: string; visibility_condition: ConditionDto; }

export interface SyntheseDto { id: string; index: number; template: string; visibility_condition: ConditionDto; }

export interface PoseDto { numero_rubrique: number; tarif_ht: number; label: string; }

//#region //* SingleChoice - MultipleChoices

export enum ChoiceDisplayStyle {
    BigSquares = 'BigSquares',
    LittleRectangles = 'LittleRectangles',
    CardsWithDetails = 'CardsWithDetails',
    Supplement = 'Supplement',
}

export interface OptionDto {
    readonly id: string;
    readonly label: string;
    readonly description?: string;
    readonly show_only_to_sellers: boolean;
    readonly is_recommended_choice: boolean;
    readonly include_price: boolean;
    readonly exclude_other_options: boolean;
    readonly index: number;
    readonly value: number;
    readonly image_id: string;
    readonly pose: PoseDto;
    readonly visibility_condition: ConditionDto;
}
export interface SingleChoiceProperties { display_style: ChoiceDisplayStyle; option_list: OptionDto[]; }
export interface MultipleChoicesProperties { option_list: OptionDto[]; display_style: ChoiceDisplayStyle; }

//#endregion

export interface NumberProperties { minimum: number; maximum: number; placeholder: string; unit: string; }
export interface CommentProperties { placeholder: string; input_type: CommentPropertiesInputType; }

export enum CommentPropertiesInputType {
    FreeText = 'FreeText',
    DateMMAAAA = 'DateMMAAAA',
}
export interface RespirationProperties { image_id: string; }

export interface ZipCodeProperties { placeholder: string; }
export interface QuestionSummary { id: string; }

//#region  PRIX

export enum FrontCalculType {
    SendToAPI = 'SendToAPI',
    FrontLaize = 'FrontLaize',
}

export interface ModeCalculDto { id: string; name: FrontCalculType; }

export enum BaseDeCalculDto {
    NoBase = 'NoBase',

    //* ROOM AND WALL
    LongueurRaccordMetre = 'LongueurRaccordMetre',
    LamePleineQuantity = 'LamePleineQuantity',

    //* ROOM
    RoomSurfaceMetreCarre = 'RoomSurfaceMetreCarre',
    RoomPerimeterMetre = 'RoomPerimeterMetre',
    RoomSurfaceManipuleeProrataMetreCarre = 'RoomSurfaceManipuleeProrataMetreCarre',

    RoomPerimeterPlinthesMetre = 'RoomPerimeterPlinthesMetre',
    RoomLongueurTotaleLaizeMetre = 'RoomLongueurTotaleLaizeMetre',


    //* WALL
    WallSurfaceMetreCarre = 'WallSurfaceMetreCarre',
    WallPerimeterMetre = 'WallPerimeterMetre',
    WallSurfaceManipuleeProrataMetreCarre = 'WallSurfaceManipuleeProrataMetreCarre',

    //* OPENING
    OpeningDimensionCentimetre = 'OpeningDimensionCentimetre',

    //* ROOM ITEM
    RoomElementsArea = 'RoomElementsArea',
    RoomElementsMetreLineaire = 'RoomElementsMetreLineaire',
    MarcheLengthMetreLineaire = 'MarcheLengthMetreLineaire',

    //* ROOM CONTOURNEMENTS
    RoomRadiatorCount = 'RoomRadiatorCount',
    RoomThingsOnAStandCount = 'RoomThingsOnAStandCount',
    RoomObstacleCount = 'RoomObstacleCount',
    RoomStoneWallMetre = 'RoomStoneWallMetre',
    RoomStairsCount = 'RoomStairsCount',
    RoomPipeOnFloorCount = 'RoomPipeOnFloorCount',
    RoomTreeCount = 'RoomTreeCount',
    RoomRailingCount = 'RoomRailingCount',

    //* WALL CONTOURNEMENTS
    WallPipeCount = 'WallPipeCount',
    WallPipeHoleCount = 'WallPipeHoleCount',
    ElectricEquipmentCount = 'ElectricEquipmentCount',
    WallPillarCount = 'WallPillarCount',
    HotspotCount = 'HotspotCount',

    //* STAIRS
    StairsTotalMarchesDroites = 'StairsTotalMarchesDroites',
    StairsTotalMarchesTournantes = 'StairsTotalMarchesTournantes',
    StairsTotalMarchesArrondies = 'StairsTotalMarchesArrondies',
    StairsTotalPaliers = 'StairsTotalPaliers',
    StairsTreadCount = 'StairsTreadCount',
    StairsRiserCount = 'StairsRiserCount',
    StairsSurface = 'StairsSurface',
    StairsTreadsSurface = 'StairsTreadsSurface',
    StairsRisersSurface = 'StairsRisersSurface',
    StairsLength = 'StairsLength',
    StairsLongueurTotaleLaizeMetre = 'StairsLongueurTotaleLaizeMetre',
}

export interface PrixDto {
    readonly id: string;
    readonly base_de_calcul_type: BaseDeCalculDto;
    readonly visibility_condition: ConditionDto;

    readonly show_only_to_sellers: boolean;
    readonly context_type: PrixContextType;
    readonly openings_context_properties: OpeningsContextPropertiesDto;
    readonly room_elements_context_properties: RoomElementsContextPropertiesDto;
    readonly famille_produit_code_list: Array<string>;
}

//#endregion

export type ExcludeResponse = { label: string; imageId: string };

export type ProductProperties = Partial<{
    is_required: boolean;
    have_suggestions: boolean;
    placeholder: string;
    catalogue_search_allowed: boolean;
    allow_copy_last_choosed_product: boolean;
    exclude_response_label?: string;
    exclude_response_image_id?: string;
}>

export interface EvaluationDto {
    readonly id: string;
    readonly index: number;
    readonly name: string;
    readonly value: string;
    readonly evaluation_condition: ConditionDto;
}

export enum IncompatibilityTypeDto {
    Produit = 'Produit',
    FinDeParcours = 'FinDeParcours',
}

export interface IncompatibilityDto {
    readonly id: string;
    readonly index: number;
    readonly explanation: string;
    readonly redirect_url: string;
    readonly cta: string;
    readonly type: IncompatibilityTypeDto;
    readonly visibility_condition: ConditionDto;
}

export interface PrestationDto {
    id: string;
    index: number;
    image_id?: string | null;
    pose: PoseDto;
    code: string;
    libelle: string;
    description: string;
    visibility_condition: ConditionDto;
}

export type MultiChoicesProduitItem = { item: ProduitDto; count: number; }
export type MultiChoicesPrestationItem = { item: PrestationDto; count: number; }

export interface OpeningsContextPropertiesDto {
    readonly is_for_porte: boolean;
    readonly is_for_porte_blindee: boolean;
    readonly is_for_porte_entree: boolean;
    readonly is_for_porte_fenetre: boolean;
    readonly is_for_passage_ouvert: boolean;
    readonly is_for_baie_vitree: boolean;
}

export interface RoomElementsContextPropertiesDto {
    readonly is_for_shower_bathtub: boolean;
    readonly is_for_fixed_furniture: boolean;
    readonly is_for_cupboard: boolean;
    readonly is_for_kitchen_furniture: boolean;
    readonly is_for_trap: boolean;
    readonly is_for_fireplace: boolean;
    readonly is_for_opening: boolean;
    readonly is_for_stairs: boolean;
    readonly is_for_divider: boolean;
    readonly is_for_heavy_element: boolean;
    readonly is_for_sewer_plate: boolean;
    readonly is_for_door: boolean;
    readonly is_for_window: boolean;
    readonly is_for_unlaid_area: boolean;
}
export interface QuestionItem {
    readonly id: string;
    readonly title: string;
    readonly label: string;
    readonly label_single_choice: string;
    readonly related_step: QuestionStep;
    readonly famille_produit_code_list: Array<string>;
    readonly additional_informations: string;
    readonly comment: string;
    readonly index: number;
    readonly type: QuestionType;
    readonly context_type: QuestionContextType;
    readonly show_only_to_sellers: boolean;

    readonly openings_context_properties: OpeningsContextPropertiesDto;
    readonly room_elements_context_properties: RoomElementsContextPropertiesDto;

    readonly number_properties: NumberProperties;
    readonly comment_properties: CommentProperties;
    readonly single_choice_properties?: SingleChoiceProperties;
    readonly multiple_choices_properties?: MultipleChoicesProperties;
    readonly respiration_properties: RespirationProperties;
    readonly zip_code_properties: ZipCodeProperties;
    //* retrieve products from question id
    //* in parameter : reference question response : id ?
    readonly produit_properties: ProductProperties;
    readonly multiple_choices_product_properties: ProductProperties;
    readonly multiple_choices_prestation_properties: ProductProperties;

    readonly infobulle_list: Array<Infobulle>;
    readonly evaluation_list: Array<EvaluationDto>;
    readonly visibility_condition: ConditionDto;
    //readonly prix_list: Array<PrixDto>;//! TO DELETE LATER
    readonly incompatibility_list: Array<IncompatibilityDto>;
    readonly synthese_list: Array<SyntheseDto>;
    readonly suggestion_list: Array<SuggestionDto>;
    readonly prestation_list: Array<PrestationDto>;

    loadingProduits?: boolean;
    produits: Array<ProduitDto>;
    produitsLoaded?: boolean;
    produitValue?: ProduitDto;
    produitPrincipalCode?: string;
    produitSearch?: string;
    needLoadProduits?: boolean;
    produitReadonlyReference?: string;

    multiChoicesProduitCartValues?: Record<string, MultiChoicesProduitItem>;
    multiChoicesPrestationCartValues?: Record<string, MultiChoicesPrestationItem>;

    excludeResponseSelected?: boolean;

    showQuestion?: boolean;
    optionValue?: OptionDto;
    optionValues?: Array<OptionDto>;
    numberValue?: string;
    commentValue?: string;

    zipCodeData?: LocalitiesSearchResultDto;
    zipCodeValue?: LocalityDto;
    zipCodeValueLoading?: boolean;
    errorInvalidNumberValue?: boolean;

    //* answer is valid
    isValid?: boolean;
    //! or user skip to next question to make it valid (question type Comment)
    //! isSkip?: boolean;

    //* review de la gestion du context sur les questions (14/03/2021)
    context: QuestionContext;
    previousVisibleQuestion?: QuestionItem;

    focusQuestion?: boolean;

    isQuestionMainProduct?: boolean;
}
